import firebase from 'firebase/app'
import Vue from 'vue'
import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'

import Task from './task_help'
Vue.use(SlimDialog)

export default {
  state: {
    tasks: []
  },
  mutations: {
    loadTasks (state, payload) {
      state.tasks = payload
    },
    newTask (state, payload) {
      state.tasks.push(payload)
    },
    editTask (state, {id, title, description, timeStart, timeStart2, idHome, time, opisaniye, datePickerStart, timePickerStart, datePickerEnd, timePickerEnd, startDate, endDate, user, boxNumber}) {
      const task = state.tasks.find(t => {
        return t.id === id
      })
      task.title = title
      task.description = description
      task.timeStart = timeStart
      task.timeStart2 = timeStart2
      task.idHome = idHome
      task.time = time
      task.opisaniye = opisaniye
      task.datePickerStart = datePickerStart
      task.timePickerStart = timePickerStart
      task.datePickerEnd = datePickerEnd
      task.timePickerEnd = timePickerEnd
      task.startDate = startDate
      task.endDate = endDate
      task.user = user
      task.boxNumber = boxNumber
    },
    editTask1 (state, {id, description, time, opisaniye, datePickerEnd, timePickerEnd, endDate}) {
      const task = state.tasks.find(t => {
        return t.id === id
      })
      task.description = description
      task.time = time
      task.opisaniye = opisaniye
      task.datePickerEnd = datePickerEnd
      task.timePickerEnd = timePickerEnd
      task.endDate = endDate
    },
    editTask3 (state, {id, time, opisaniye}) {
      const task = state.tasks.find(t => {
        return t.id === id
      })
      task.time = time
      task.opisaniye = opisaniye
    },
    editTask2 (state, {id, title, description, timeStart, timeStart2, idHome, time, opisaniye, datePickerStart, timePickerStart, datePickerEnd, timePickerEnd}) {
      const task = state.tasks.find(t => {
        return t.id === id
      })
      task.title = title
      task.description = description
      task.timeStart = timeStart
      task.timeStart2 = timeStart2
      task.idHome = idHome
      task.time = time
      task.opisaniye = opisaniye
      task.datePickerStart = datePickerStart
      task.timePickerStart = timePickerStart
      task.datePickerEnd = datePickerEnd
      task.timePickerEnd = timePickerEnd
    },
    completedTask (state, {id, completed, time, boxNumber}) {
      const task = state.tasks.find(t => {
        return t.id === id
      })
      task.completed = completed
      task.time = time
      task.boxNumber = boxNumber
    }
  },
  actions: {
    // Load all Tasks
    async loadTasks ({commit}) {
      commit('clearError')
      commit('setLoading', true)
      try {
        // Get task
        const task = await firebase.database().ref('tasks').once('value')
        // Get value
        const tasks = task.val()
        // New array
        const tasksArray = []
        // Get task key (id)
        Object.keys(tasks).forEach(key => {
          const t = tasks[key]
          tasksArray.push(
            new Task(
              t.title,
              t.description,
              t.whatWatch,
              t.time,
              t.tags,
              t.completed,
              t.editing,
              t.user,
              key,
              t.timeStart,
              t.timeStart2,
              t.idHome,
              t.opisaniye,
              t.datePickerStart,
              t.timePickerStart,
              t.datePickerEnd,
              t.timePickerEnd,
              t.boxNumber,
              t.startDate,
              t.endDate
            )
          )
        })
        // Send mutation
        commit('loadTasks', tasksArray)

        commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    // Create new Task
    async newTask ({commit, getters}, payload) {
      commit('clearError')
      commit('setLoading', true)
      try {
        // Used helped class
        const newTask = new Task(
          payload.title,
          payload.description,
          payload.whatWatch,
          payload.time,
          payload.tags,
          payload.completed,
          payload.editing,
          getters.user.id,
          payload.timeStart,
          payload.timeStart2,
          payload.idHome,
          payload.opisaniye,
          payload.datePickerStart,
          payload.timePickerStart,
          payload.datePickerEnd,
          payload.timePickerEnd,
          payload.boxNumber
        )
        // Push newTask
        const task = await firebase.database().ref('tasks').push(newTask)

        // Send mutation
        commit('newTask', {
          ...newTask,
          id: task.key
        })

        commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    // Edit Task (popup)
    async editTask ({commit}, {id, title, description, timeStart, timeStart2, idHome, time, opisaniye, datePickerStart, timePickerStart, datePickerEnd, timePickerEnd, startDate, endDate, user, boxNumber}) {
      commit('clearError')
      commit('setLoading', true)
      try {
        // КОНЕЧНАЯ ДАТА
        console.log(description[0])
        var testStart1 = 1
        var testStart2 = 1
        var testTitle1 = 1
        var testDescription2 = 1
        // Конечное время
        if (testStart1 && testStart2 && testTitle1 && testDescription2 === 1) {
          const idGeneratorForGuest = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
          idHome = idGeneratorForGuest
          console.log(timePickerStart)

          startDate = (datePickerStart + ' ' + timePickerStart)
          endDate = (datePickerEnd + ' ' + timePickerEnd)

          var date = new Date()
          var dd = String(date.getDate()).padStart(2, '0')
          var mm = String(date.getMonth() + 1).padStart(2, '0')
          var yyyy = date.getFullYear()

          var time1 = ''
          var dateForFilter = ''
          var adress = time

          // var time1 = date.getHours() + ':' + date.getMinutes()

          if (date.getMinutes() < 10) {
            console.log(date.getMinutes())
            time1 = date.getHours() + ':' + '0' + date.getMinutes()
          } else {
            time1 = date.getHours() + ':' + date.getMinutes()
          }

          date = dd + '.' + mm + '.' + yyyy + ' ' + time1
          dateForFilter = mm + '.' + yyyy

          var flatId = id
          var name = 'WEB Версия'

          await firebase.database().ref('tasks').child(id).update({
            idHome,
            startDate,
            endDate,
            time,
            opisaniye
            // timePickerStartNormal
          })
          await firebase.database().ref('users/').child(user + '/codes/').push({
            adress,
            idHome,
            date,
            flatId,
            dateForFilter,
            boxNumber,
            name
            // timePickerStartNormal
          })
          // Send mutation
          commit('editTask', {id, title, description, timeStart, timeStart2, idHome, time, opisaniye, datePickerStart, timePickerStart, datePickerEnd, timePickerEnd, startDate, endDate, user, boxNumber})

          commit('setLoading', false)
        }
        // НАчальное время
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    async editTask1 ({commit}, {id, description, time, opisaniye, datePickerEnd, timePickerEnd, startDate, endDate}) {
      commit('clearError')
      commit('setLoading', true)
      try {
        // КОНЕЧНАЯ ДАТА
        console.log(description[0])
        var testStart1 = 1
        var testStart2 = 1
        var testTitle1 = 1
        var testDescription2 = 1
        // Конечное время
        if (testStart1 && testStart2 && testTitle1 && testDescription2 === 1) {
          // const idGeneratorForGuest = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
          // var date = title
          // console.log(timePickerStart)

          endDate = (datePickerEnd + ' ' + timePickerEnd)

          await firebase.database().ref('tasks').child(id).update({
            endDate,
            time,
            opisaniye
            // timePickerStartNormal
          })
          // Send mutation
          commit('editTask1', {id, description, time, opisaniye, datePickerEnd, timePickerEnd, endDate})

          commit('setLoading', false)
        }
        // НАчальное время
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    async editTask2 ({commit}, {id, title, description, idHome, time, opisaniye, datePickerStart, timePickerStart, datePickerEnd, timePickerEnd}) {
      commit('clearError')
      commit('setLoading', true)
      try {
        // КОНЕЧНАЯ ДАТА
        console.log(description[0])
        var testStart1 = 1
        var testStart2 = 1
        var testTitle1 = 1
        var testDescription2 = 1
        // Конечное время
        if (testStart1 && testStart2 && testTitle1 && testDescription2 === 1) {
          const idGeneratorForGuest = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
          idHome = idGeneratorForGuest
          console.log(timePickerStart)

          var startDate = (datePickerStart + ' ' + timePickerStart)
          var endDate = (datePickerEnd + ' ' + timePickerEnd)

          await firebase.database().ref('tasks').child(id).update({
            idHome,
            startDate,
            endDate,
            time,
            opisaniye
            // timePickerStartNormal
          })
          // Send mutation
          commit('editTask2', {id, title, description, idHome, time, opisaniye})

          commit('setLoading', false)
        }
        // НАчальное время
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    async editTask3 ({commit}, {id, time, opisaniye}) {
      commit('clearError')
      commit('setLoading', true)
      try {
        // КОНЕЧНАЯ ДАТА
        var testStart1 = 1
        var testStart2 = 1
        var testTitle1 = 1
        var testDescription2 = 1
        // Конечное время
        if (testStart1 && testStart2 && testTitle1 && testDescription2 === 1) {
          // const idGeneratorForGuest = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000
          // var date = title
          // console.log(timePickerStart)

          await firebase.database().ref('tasks').child(id).update({
            time,
            opisaniye
            // timePickerStartNormal
          })
          // Send mutation
          commit('editTask3', {id, time, opisaniye})

          commit('setLoading', false)
        }
        // НАчальное время
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    // Change Completed

    async completedTask ({commit}, {id, user, completed, time, boxNumber}) {
      commit('clearError')
      commit('setLoading', true)
      try {
        var status0 = 1
        var statusBaseBoll = true
        console.log(status0)
        console.log(id)
        console.log(user)
        // Update title & descr
        if (completed === false) {
          status0 = 1
          statusBaseBoll = true
        }
        if (completed === true) {
          status0 = 0
          statusBaseBoll = false
        }
        await firebase.database().ref('tasks').child(id).update({
          completed
        })
        await firebase.database().ref('tasks/').child(id + '/lock').update({
          status: status0
        })
        // await firebase.database().ref('tasks/landlordDoorsStatus').child(user + '/' + id).update({
        //  id: statusBaseBoll
        // })

        await firebase.database().ref('tasks/landlordDoorsStatus').child(user).child(id).set(statusBaseBoll)

        var date = new Date()
        var dd = String(date.getDate()).padStart(2, '0')
        var mm = String(date.getMonth() + 1).padStart(2, '0')
        var yyyy = date.getFullYear()

        var time1 = ''
        // var time1 = date.getHours() + ':' + date.getMinutes()
        if (date.getMinutes() < 10) {
          console.log(date.getMinutes())
          time1 = date.getHours() + ':' + '0' + date.getMinutes()
        } else {
          time1 = date.getHours() + ':' + date.getMinutes()
        }

        date = dd + '.' + mm + '.' + yyyy + ' ' + time1
        var flatId = id
        var adress = time
        var name = 'WEB Версия'
        var status
        if (status0 === 0) {
          status = false
        } else {
          status = true
        }

        await firebase.database().ref('users/').child(user + '/analytic/').push({
          adress,
          boxNumber,
          date,
          flatId,
          name,
          status
          // timePickerStartNormal
        })

        // Send mutation
        commit('completedTask', {id, completed, time, boxNumber})

        commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    // Delete Task (button)
    async deleteTask ({commit}, id) {
      commit('clearError')
      commit('setLoading', true)
      try {
        var database = firebase.database()
        var ref = database.ref('tasks/').child(id + '/lock')
        var data = {
          status: 2
          // completed: true
        }
        ref.set(data)
        // await firebase.database().ref('tasks').child(id).remove()
        console.log(data.score)
        console.log('')
        // commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    async openHome ({commit}, id) {
      commit('clearError')
      commit('setLoading', true)
      try {
        var database = firebase.database()
        var ref = database.ref('tasks/').child(id + '/lock')
        var data = {
          status: 1
          // completed: true
        }
        ref.set(data)
        // await firebase.database().ref('tasks').child(id).remove()
        console.log('Открыто')
        // commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    async closeHome ({commit}, id) {
      commit('clearError')
      commit('setLoading', true)
      try {
        var database = firebase.database()
        var ref = database.ref('tasks/').child(id + '/lock')
        var data = {
          status: 0
          // completed: true
        }
        const idx = Math.floor(Math.random() * (999999 - 100000 + 1)) + 1
        console.log(idx)
        ref.set(data)
        // await firebase.database().ref('tasks').child(id).remove()
        console.log('Закрыто')
        // commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    async stopDostup ({commit}, {id, title, description, timeStart, timeStart2, idHome}) {
      commit('clearError')
      commit('setLoading', true)
      try {
        title = '00.00.0000'
        description = '00.00.0000'
        timeStart = '00:00'
        timeStart2 = '00:00'
        idHome = 0

        var startDate = (title + ' ' + timeStart)
        var endDate = (description + ' ' + timeStart2)

        await firebase.database().ref('tasks').child(id).update({
          idHome,
          startDate,
          endDate
        })
        // await firebase.database().ref('tasks').child(id).remove()
        console.log('Закрыто')
        // commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    async openHomeWithId ({commit}, id) {
      commit('clearError')
      commit('setLoading', true)
      try {
        var database = firebase.database()
        var ref = database.ref('tasks/').child(id + '/flatId')
        const idx = Math.floor(Math.random() * (999999 - 100000 + 1)) + 1
        var data = {
          id: idx
          // completed: true
        }
        ref.set(data)
        // await firebase.database().ref('tasks').child(id).remove()
        console.log('Код квартиры' + idx)
        // commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    },
    // Точка не возврата
    async deleteTask1 ({commit}, id) {
      commit('clearError')
      commit('setLoading', true)
      try {
        var database = firebase.database()
        var ref = database.ref('tasks').child(id)

        var data = {
          name: 'DTS',
          score: 43
        }
        ref.push(data)
        // await firebase.database().ref('tasks').child(id).remove()
        console.log(data)
        console.log('хуй')
        // commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
      }
    }
  },
  getters: {
    // Get All user Tasks
    tasks (state, getters) {
      return state.tasks.filter(task => {
        return task.user === getters.user.id
      })
    },
    // Get user Completed Tasks
    taskCompleted (state, getters) {
      return getters.tasks.filter(task => {
        console.log('комплит')
        return task.completed
      })
    },
    // Get user Active Tasks
    taskNotCompleted (state, getters) {
      return getters.tasks.filter(task => {
        console.log('не комплит')
        return task.completed === false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/tasks.js